import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { DocumentVersionsService } from '../document-versions.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DefaultSnackBarService } from '../../../../services/default-snack-bar.service';
import { DocumentTrackingService } from '../../document-tracking.service';
import ID from '../../../../types/id';
import { combineLatest, Subscription } from 'rxjs';
import DocType from '../../../../interfaces/doc-type';
import DocStatus from '../../../../interfaces/doc-status';
import { FormControl, FormGroup } from '@angular/forms';
import { formatDate } from '@angular/common';
import { CreateVersionInput } from '../graphql/document-versions';
import { CurrentUserService } from '../../../../services/current-user.service';

type AddVersionDialogData = {
  docTypeId: ID;
  docId: ID;
  versionsService: DocumentVersionsService;
};
@Component({
    selector: 'app-add-version-modal',
    templateUrl: './add-version-modal.component.html',
    styleUrls: ['./add-version-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddVersionModalComponent {
  docTypeId: ID;
  docId: ID;
  infoSub: Subscription;
  docType: DocType;
  statuses: DocStatus[] = [];
  controls = new FormGroup({
    doc_subtype_id: new FormControl<ID | null>(null),
    doc_status_id: new FormControl<ID | null>(null),
    version: new FormControl<number | null>(null),
    status_date: new FormControl<Date | string>(''),
  });
  formSub: Subscription;

  public documentVersionService: DocumentVersionsService;
  constructor(
    public documentTrackerService: DocumentTrackingService,
    public userService: CurrentUserService,
    public dialogRef: MatDialogRef<AddVersionModalComponent>,
    private _snackBar: DefaultSnackBarService,
    @Inject(MAT_DIALOG_DATA) data: AddVersionDialogData
  ) {
    this.docId = data.docId;
    this.docTypeId = data.docTypeId;
    this.documentVersionService = data.versionsService;
  }
  ngOnInit() {
    this.infoSub = combineLatest({
      docTypes: this.documentTrackerService.docTypes$,
    }).subscribe(({ docTypes }) => {
      let docType = docTypes.find((iDocType) => this.docTypeId === iDocType.id);
      if (docType) {
        this.docType = docType;
      }
    });
    this.formSub = this.controls.controls.doc_subtype_id.valueChanges.subscribe(
      (value) => {
        if (value) {
          this.statuses = this.docType.docTypeSubtypeStatuses
            .filter((docTypeStatus) => docTypeStatus.doc_subtype_id === value)
            .sort((a, b) => a.sort_order - b.sort_order)
            .map((docTypeStatus) => docTypeStatus.docStatus);
        } else {
          this.statuses = [];
        }
      }
    );
  }
  save() {
    let values = this.controls.value;
    this.userService.user$.subscribe((user) => {
      if (user) {
        let input = {
          doc_subtype_id: values.doc_subtype_id,
          doc_status_id: values.doc_status_id,
          version: values.version,
          status_date: formatDate(
            values.status_date ?? new Date(),
            'yyyy-MM-dd',
            'en-US'
          ),
          document_id: this.docId,
          user_id: user.id,
        };
        this.documentVersionService
          .createVersion(input as CreateVersionInput)
          .subscribe(({ data, loading }) => {
            if (data?.createDocVersion) {
              this._snackBar.open('Successfully logged file history');
              this.documentVersionService.getVersions(this.docId);
              this.dialogRef.close();
            }
          });
      }
    });
  }
}
